import { MLanguageFiles } from '@elte/translate-backend/interface/lang_file';

export type TFlatJsonStruct = { key: string; value: string; translate: string };

type TFlatJson = {
    list: TFlatJsonStruct[];
};

export function flatJson(jsonOriginalLang: MLanguageFiles.TLanguageFile, jsonTranslateLang: MLanguageFiles.TLanguageFile): TFlatJson {
    // data structure = [{key:"test1.test12",value:"value1",translate:"value1-translate"}]
    let mapa = new Map<string, { key: string; value: string; translate: string }>();

    let errorInSourceKeys: string[] = [];
    // let errorInSource: string[] = [];
    // let differencesInFiles: string[] = [];

    // zczytywanie wartosci value1,2,3,4
    const printValues = (tree: string, arg: object) => {
        for (let v in arg) {
            let dd = tree + '.' + v;
            if (arg[v] instanceof Object) {
                printValues(dd, arg[v]);
            } else {
                let key = dd.substring(1);
                if (~v.indexOf('.')) {
                    errorInSourceKeys.push(dd);
                    // errorInSource.push(v);
                } else {
                    mapa.set(dd, { key, value: arg[v], translate: '' });
                }
            }
        }
    };

    printValues('', jsonOriginalLang);
    let errorInTarget: string[] = [];
    let errorInTargetKeys: string[] = [];
    // zczytywanie value-translate
    const printValuesTranslate = (tree: string, arg: object) => {
        for (let v in arg) {
            let dd = tree + '.' + v;
            if (arg[v] instanceof Object) {
                printValuesTranslate(dd, arg[v]);
            } else {
                let h = mapa.get(dd);
                if (h) {
                    h.translate = arg[v];
                } else {
                    // ~v.indexOf('.') && errorInTarget.push(v);
                    ~v.indexOf('.') && errorInTargetKeys.push(dd);
                    // differencesInFiles.push(dd);
                }
            }
        }
    };

    const pritCorrectList = (): TFlatJsonStruct[] => {
        errorInSourceKeys.forEach((item) => {
            mapa.delete(item);
        });
        errorInTargetKeys.forEach((item) => {
            mapa.delete(item);
        });
        return [...mapa.values()];
    };

    printValuesTranslate('', jsonTranslateLang);

    const filteredList = pritCorrectList();

    // console.log('errorInSource', errorInSource, 'errorInTarget', errorInTarget, 'differencesInFiles', differencesInFiles);

    return {
        list: filteredList
    };
}
